import { defineNamespace } from '../core';
import { en } from './en';
import { fr } from './fr';

export const labels = defineNamespace('labels', fr, en);
